// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Cutam.jpg";
import thumb1 from "../assets/images/All-Products/cutam.png";
import thumb2 from "../assets/images/New-Products/Cutam.jpg";
import thumb3 from "../assets/images/All-Products/Cutam2.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Cutam Palm and Sole</h2>
              <p className="sub-heading text-muted">Innovative Urea Repair </p>
              <h5>Product Overview</h5>
              <p>
                Cutam palm & sole cream delivers effective relief for dry,
                chapped hands & feet with an innovative urea repair formula fortified with ceramides and other essentials.
                This clinically proven, formula rapidly heals dry hands & feet.
                It noticeably improves the look and feel of your skin.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Cutam?</span>
                </h3>
                <p>
                  To be used as daily care for dry and rough skin. Apply regularly in the morning and evening to the affected area
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Creates a hydrolipid barrier that softens and smoothens the skin.</li>
                    <li>Delivers effective relief for dry, chapped hands &amp; feet with innovative urea repair formula fortified with ceramides &amp; other essentials.</li>
                    <li>Increases skin’s moisture level &amp; helps prevent water loss.</li>
                  </ul>


                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>To be used as daily care for dry and rough skin.</li>
                      <li>Apply regularly in the morning and evening to the affected area.</li>
                      <li>Gently massage into the skin, particularly the affected skin until completely absorbed.</li>
                    </ol>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Urea 20%:</strong> Helps improve the appearance of dry, rough, scaly skin by providing hydration to smoothen texture and by reducing the build-up of dead skin cells. It acts as an exfoliator and humectant.</li>
                      <li><strong>SK Influx:</strong> Skin-identical lipid concentrate that maintains the skin’s natural barrier and comprises ceramide 1, 3, & 6, fatty acid, cholesterol, and phytosphingosine.</li>
                      <li><strong>Veg lanolin:</strong> Acts as a semi-occlusive agent, providing moisturization and soothing the skin.</li>
                      <li><strong>Lipids:</strong> Protect the skin barrier and prevent dryness.</li>
                    </ul>
                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
